import React from 'react';
import 'twin.macro';
import DateInput from 'components/Form/Dateinput2';
import { useTranslation } from 'react-i18next';
import { buttonRootStyle } from 'components/Buttons/Button';
import tw, { css } from 'twin.macro';
import { format } from 'utils/time/format';
import { UserLocale } from '@teetsh/app/src/types/user';

interface Props {
  value?: Date;
  onChange: (v?: Date | null) => any;
  readonly?: boolean;
}

export function DateCell(props: Props) {
  const { onChange, readonly } = props;
  const { t } = useTranslation(['eleve', 'common']);
  const [date, setDate] = React.useState<Date | undefined | null>(props.value);
  const [editing, setEditing] = React.useState<boolean>(false);

  if (readonly) {
    return (
      <div>
        {date ? (
          <span>
            {format(
              date,
              t('common:locale.long') as UserLocale,
              t('common:datePattern.dd/MM/yyyy'),
            )}
          </span>
        ) : (
          <span tw="invisible">2023/01/01</span>
        )}
      </div>
    );
  }

  if (!editing) {
    return (
      <div tw="max-w-[6rem]">
        <div
          css={[
            buttonRootStyle({ minimal: false, fill: true }),
            tw`cursor-pointer justify-start bg-transparent border-opacity-0 hover:border-opacity-100 border-neutral-quiet text-sm px-1 py-1.5!`,
            !date && tw`border-opacity-100 md:border-opacity-100`,
          ]}
          onClick={() => {
            setEditing(true);
          }}
        >
          {!date ? (
            <span tw="invisible">2023/01/01</span>
          ) : (
            <span>
              {format(
                date,
                t('common:locale.long') as UserLocale,
                t('common:datePattern.dd/MM/yyyy'),
              )}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <DateInput
        onClickOutside={() => {
          setTimeout(() => {
            // set timeout to avoid unmounting the component before child component triggers onBlur
            setEditing(false);
          }, 100);
        }}
        openOnMount
        userLocale={t('common:locale.long') as UserLocale}
        css={[
          tw`border border-gray-300! outline-none ring-0 px-1 py-1.5 font-medium max-w-24 md:max-w-full`,
          css`
            box-shadow: none !important;
          `,
        ]}
        canBeNull
        id="birthday"
        portal
        placeholder={''}
        value={date}
        onChange={v => {
          setDate(v);
          onChange(v);
        }}
      />
    </div>
  );
}
